import { Group, Text } from '@mantine/core';
import { useProfile } from 'init/use-enforce-profile';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadMail } from 'modules/Mails/hooks';
import { useMailDetailNavigation } from 'modules/Mails/pages/MailDetail/hooks/use-mail-detail-navigation';
import { useMailDetailReply } from 'modules/Mails/pages/MailDetail/hooks/use-mail-detail-reply';
import { useParams } from 'react-router';
import { KeyboardHint } from './KeyboardHint';

export const MailDetailKeyboardHints = () => {
  const { t } = useTranslation();
  const profile = useProfile();
  const { id } = useParams<{ id: string }>();

  const { thread } = useLoadMail(id);
  const { unprocessedNavigation } = useMailDetailNavigation(id);
  const { isReplyEnabled } = useMailDetailReply();

  return (
    <Group gap="space3" c="dimmed" visibleFrom="sm">
      <Text size="xs">{t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_PRESS)}</Text>
      {isReplyEnabled && (
        <KeyboardHint kbd="R" label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_TO_REPLY)} />
      )}
      <KeyboardHint
        kbd="E"
        label={t(
          thread.isProcessed
            ? i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_TO_UNMARK_PROCESSED
            : i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_TO_MARK_PROCESSED,
        )}
      />
      {profile.isAdmin && (
        <KeyboardHint kbd="A" label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_TO_ASSIGN)} />
      )}
      {unprocessedNavigation?.hasNext && (
        <KeyboardHint
          kbd="J"
          label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_NEXT_UNPROCESSED)}
        />
      )}
      {unprocessedNavigation?.hasPrev && (
        <KeyboardHint
          kbd="K"
          label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_PREV_UNPROCESSED)}
        />
      )}
    </Group>
  );
};
